import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Notifications, {notify} from 'react-notify-toast';
import { get, post } from 'axios';
import { inject, observer } from 'mobx-react';
import Modal from 'react-bootstrap4-modal';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, ContentState, convertFromHTML } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

class EmailForm extends Component{
    constructor(props){
        super(props);
        this.state = {
            editorState: EditorState.createEmpty(),
            email:null
        }
        this.saveEmail = this.saveEmail.bind(this);
    }

    componentWillReceiveProps(nextProps){
        if (nextProps.email){
            const blocksFromHTML = convertFromHTML(nextProps.email.body);
            const state = ContentState.createFromBlockArray(
              blocksFromHTML.contentBlocks,
              blocksFromHTML.entityMap
            );
            this.setState({
                editorState: EditorState.createWithContent(state),
                email:nextProps.email
            })
        }
    }

    saveEmail(){
        this.props.handleBodyChange(stateToHTML(this.state.editorState.getCurrentContent()));
    }

    onEditorStateChange = (editorState) => {
        this.setState({
            editorState
        });
        //, ()=>{this.props.handleBodyChange(stateToHTML(editorState.getCurrentContent()))}
    }


    render(){
        if (!this.props.email) return <div className="alert alert-info">Loading Email...</div>;
        const {editorState} = this.state;
        const {handleInputChange, email, modalBackgroundClicked} = this.props;
        return (
        <React.Fragment>
            <div className="modal-body">
                <div className="form-group">
                    <label>Subject</label>
                    <input className="form-control" name="subject" type="text" onChange={handleInputChange} value={email.subject}/>
                </div>
                <div className="form-group">
                    <label>Description</label>
                    <textarea className="form-control" name="description" onChange={handleInputChange} value={email.description}></textarea>
                </div>
                <div className="form-group">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" value="" id="do-not-send" name="do_not_send" onChange={handleInputChange} checked={email.do_not_send && email.do_not_send === 1 ? true : false}/>
                      <label class="form-check-label" for="do-not-send">
                        Do Not Send Email?
                      </label>
                    </div>
                </div>
                <div className="form-group">
                    <Editor
                        editorState={editorState}
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperClassName"
                        editorClassName="editorClassName"
                        onEditorStateChange={this.onEditorStateChange}
                    />
                </div>
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={modalBackgroundClicked}>Close</button>
                <button type="button" className="btn btn-primary" onClick={this.saveEmail}>Save</button>
            </div>
        </React.Fragment>
        )
    }
}

@inject('userStore')
class SettingsEmail extends Component {
    constructor(props){
        super(props);
        this.state = {
            business:null,
            email_list:[],
            visible:false,
            selectedItem:null,
            preview:false
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleBodyChange = this.handleBodyChange.bind(this);
        this.fetchEmailList = this.fetchEmailList.bind(this);
        this.onEditorStateChange = this.onEditorStateChange.bind(this);
        this.modalBackgroundClicked = this.modalBackgroundClicked.bind(this);
        this.modalHandler = this.modalHandler.bind(this);
    }

    componentDidMount(){
        this.setState({
            business:this.props.business
        }, () => {this.fetchEmailList()});
    }

    modalBackgroundClicked(){
        this.setState({
            visible:!this.state.visible, selectedItem:null
        });
    }

    modalHandler(email, preview){
        this.setState({
            selectedItem:email,
            preview:preview
        },()=>this.setState({visible:!this.state.visible}))
    }

    onEditorStateChange(){

    }

    handleInputChange(e) {
        let updatedItem = Object.assign({}, this.state.selectedItem);
        // const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        let value = e.target.value;
        if (e.target.type === 'checkbox'){
          if (e.target.checked){
            value = 1;
          } else {
            value = 0;
          }
        }
        updatedItem[e.target.name] = value;
        this.setState({selectedItem:updatedItem});
    }

    handleBodyChange(body){
        let updatedItem = Object.assign({}, this.state.selectedItem);
        const value = body;
        updatedItem.body = value;
        this.setState({
            selectedItem:updatedItem
        }, ()=>this.saveEmail());
    }


    fetchEmailList(){
        if (this.state.business){
            post('/v2/get/email_list', {business_hash_id:this.state.business.hash_id},{
                auth: {username: this.props.userStore.token}
            }).then((res) => {
                if (res.data.errors === 0){
                    this.setState({email_list:res.data.email_list});
                } else {
                    notify.show(res.data.message, "error", 4000);
                }
            }).catch((error) => {
                notify.show(error, "error", 4000);
                console.log(error);
                return error;
            });
        }
    }

    saveEmail = () => {
        post('/v2/save/email', {item:this.state.selectedItem},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors === 0){
                this.fetchEmailList();
                this.setState({visible:false}, () => {
                  notify.show(res.data.message, "success", 4000);
                });
            } else {
                this.setState({visible:false}, () => {
                  notify.show(res.data.message, "error", 4000);
                });
            }
        }).catch((error) => {
            this.setState({visible:false}, () => {
              notify.show(error, "error", 4000);
            });
            console.log(error);
            return error;
        });
    }

    render(){
        if (!this.state.email_list) return <div className="alert alert-info">Loading...</div>;
        return (
        <React.Fragment>
        <Notifications/>
        <Modal visible={this.state.visible} onClickBackdrop={() => this.modalBackgroundClicked()} dialogClassName="modal-lg w-900px">
            <div className="modal-header">
                <h4 className="modal-title">{this.state.selectedItem ? this.state.selectedItem.subject : null}</h4>
                <button type="button" className="close" onClick={() => this.modalBackgroundClicked(null)} aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
            </div>
            {this.state.preview && this.state.selectedItem ?
                <React.Fragment>
                <div className="modal-body">
                    <div className="card card-body article">
                        <header className="text-center">
                            <h1>{this.state.selectedItem.subject}</h1>
                        </header>
                        <div className="container-article">
                            <p className="lead" dangerouslySetInnerHTML={{__html: this.state.selectedItem.body}}/>
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={() => this.modalBackgroundClicked(null)}>
                      Close
                    </button>
                </div>
                </React.Fragment>
                 :
                <EmailForm handleInputChange={this.handleInputChange} email={this.state.selectedItem} modalBackgroundClicked={this.modalBackgroundClicked} handleBodyChange={this.handleBodyChange}/>
             }
        </Modal>
        <div className="card">
            <h4 className="card-title"><strong>Emails</strong></h4>
            <div className="card-body">
            {this.state.email_list ?
                <table className="table">
                    <thead>
                        <tr>
                            <th>Subject</th>
                            <th>Description</th>
                            <th>Custom?</th>
                            <th>Send Email</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                    {this.state.email_list.map((email, index)=>
                        <tr key={index}>
                          <td className="v-align-middle">{email.subject}</td>
                          <td className="v-align-middle"><span dangerouslySetInnerHTML={{__html: email.description}}/></td>
                          <td className="v-align-middle">{email.is_custom ? <span className="badge badge-success">YES</span> : <span className="badge badge-danger">NO</span> }</td>
                          <td className="v-align-middle">{email.is_custom ? !email.do_not_send && email.do_not_send !== 1 ? <span className="badge badge-success">YES</span> : <span className="badge badge-danger">NO</span> : <span className="badge badge-success">YES</span>}</td>
                          <td className="v-align-middle">
                            <div className="btn-group btn-group-vertical">
                                <button className="btn btn-sm btn-info" onClick={()=>this.modalHandler(email, true)}>Preview</button>
                                <button className="btn btn-sm btn-primary" onClick={()=>this.modalHandler(email, false)}>Edit</button>
                            </div>
                          </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            : null}
            </div>
        </div>
        </React.Fragment>
        );
    }
}

export default SettingsEmail;



// WEBPACK FOOTER //
// ./src/components/business/SettingsEmail.js